<template>
  <div
    class="banner"
    @click="handleCTAButtonClick"
  >
    <img
      alt="free exercise mat"
      class="banner__image"
      src="@us/app/assets/img/mat.png"
    />
    <div class="banner__content">
      <p class="kds-typography-title-medium">
        {{ $t('landing_page__mat_banner__title', { date: completesAt }) }}
      </p>
      <p
        class="kds-typography-ui-subtle-large"
        v-html="description"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'petite-vue-i18n'
import {
  INCENTIVE_TRIGGERS,
  INCENTIVE_VARIANTS,
} from '@shared/data/models/corporate.js'

const { locale, t } = useI18n()

const props = defineProps({
  handleCTAButtonClick: {
    type: Function,
    default: () => {},
  },
  incentive: {
    type: Object,
    default: undefined,
  },
})

const getFallbackIncentive = () => {
  //calculate date for next saturday
  const date = new Date()
  const daysUntilSaturday = (6 - date.getDay() + 7) % 7
  date.setDate(date.getDate() + daysUntilSaturday)

  return {
    variant: INCENTIVE_VARIANTS.mat,
    trigger: INCENTIVE_TRIGGERS.firstActivity,
    completesAt: date,
  }
}

const incentive = computed(() => props.incentive || getFallbackIncentive())

const completesAt = computed(() =>
  incentive.value.completesAt.toLocaleDateString(locale.value, {
    month: 'long',
    day: 'numeric',
  }),
)

const description = computed(() =>
  incentive.value.trigger === INCENTIVE_TRIGGERS.secondActivity
    ? t('landing_page__mat_banner__second_activity_description')
    : t('landing_page__mat_banner__description'),
)
</script>

<style lang="scss" scoped>
.banner {
  @include flex-container(row, center, 0, start);
  width: 100%;
  background-color: $kds-color-background-green-strong;
  box-sizing: border-box;
  text-align: end;
  padding: 10px;
  cursor: pointer;

  @include media-up(436px) {
    @include flex-container(row, center, sm, center);
    text-align: start;
  }

  @include media-up(md) {
    @include flex-container(row, center, md, center);
  }

  .banner__image {
    width: 120px;
    transform: rotate(-20deg) translateY(12px);
    margin: -5px -15px;

    @include media-up(436px) {
      width: 200px;
      transform: unset;
      margin: -33px -20px;
    }
  }

  .banner__content {
    z-index: 1;
    @include flex-container(column, flex-start, 0);
  }
}
</style>
